import {createSlice} from "@reduxjs/toolkit"
import { RootState } from "../DashboardStore"
import { MassagedDataType, MassagedUserData, StaticDataResponse, TimeDataResponse, UserAvatars, UserDataResponse, UserInventoryObject, UserSkillObject } from "../../Types/DataTypes"
import { calcualtePercentages, masasgeTimeData, massageUserData } from "./DataSliceFunctions"

interface DataState {
    staticData: StaticDataResponse | undefined
    timeData: TimeDataResponse | undefined
    userData: UserDataResponse | undefined
    userSkills : Array<string> | undefined
    allUserSkillData : UserSkillObject | undefined
    allUserAvatarUrls: UserAvatars | undefined
    allUserInventories: UserInventoryObject | undefined
    massagedTimeData:  MassagedDataType
    percentages: Array<number>
    loading: boolean
}

const initialState: DataState = {
    staticData: undefined,
    timeData: undefined,
    userData: undefined,
    userSkills: undefined,
    allUserSkillData: undefined,
    allUserAvatarUrls: undefined,
    allUserInventories: undefined,
    massagedTimeData: [],
    percentages: [],
    loading: true
}

export const DataSlice = createSlice({
    name: 'data',
    initialState,
    reducers : {
        setStaticData: (state,action) => {
            state.staticData = action.payload;
        },
        setTimeData: (state,action) => {
            state.timeData = action.payload;
            state.percentages = calcualtePercentages(action.payload);
        },
        setUserData : (state,action) => {
            // store all of the data from the request
            state.userData = action.payload ? action.payload : undefined;

            // massage all data in as little iterations as possible, reduction from 4 loops to 2.
            const allUserDataMassaged: MassagedUserData = massageUserData(action.payload)

            // assign all massaged data to their respective state
            state.allUserSkillData = allUserDataMassaged.allUserSkillData;
            state.allUserAvatarUrls = allUserDataMassaged.allUserAvatarUrls;
            state.userSkills = allUserDataMassaged.skillList;
            state.allUserInventories = allUserDataMassaged.allUserInventories;

        },
        setMassagedTimeData: (state,action) => {
            state.massagedTimeData = masasgeTimeData(action.payload);
        },
        setLoading: (state,action) => {
            state.loading   = action.payload
        }
    }
})

export const {setStaticData, setTimeData,setUserData, setMassagedTimeData, setLoading } = DataSlice.actions;
export const selectStaticData = (state:RootState) => state.data.staticData;
export const selectTimeData = (state:RootState) => state.data.timeData;
export const selectUserData = (state:RootState) => state.data.userData;
export const selectUserSkills = (state:RootState) => state.data.userSkills;
export const selectAllUserSkillData = (state:RootState) => state.data.allUserSkillData;
export const selectAllUserAvatars = (state:RootState) => state.data.allUserAvatarUrls;
export const selectUserInventories = (state:RootState) => state.data.allUserInventories;
export const selectMassagedTimeData = (state:RootState) => state.data.massagedTimeData;
export const selectPercentages = (state:RootState) => state.data.percentages;
export const selectLoading = (state:RootState) => state.data.loading;
export default DataSlice.reducer;